import { render } from "./UserTable.vue?vue&type=template&id=4bb1be14"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=4bb1be14&lang=css"

import exportComponent from "/Users/perthpiti/InsightEra/ENOLA/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__